import { NgModule } from "@angular/core";
import { LocalStorageModule } from "angular-2-local-storage";
import { NSAngular } from "../../shared/types";

import { StorageRef } from "./storage.service";

export const MODULE_IMPORTS: NSAngular.Import[] = [
    LocalStorageModule.withConfig({
        prefix: "isp-app",
        storageType: "localStorage",
    }),
];

export const MODULE_PROVIDERS: NSAngular.Provider[] = [
    StorageRef,
];

export const MODULE_DECLARATIONS: NSAngular.Declaration[] = [];

@NgModule({
    declarations: MODULE_DECLARATIONS,
    imports: MODULE_IMPORTS,
    providers: MODULE_PROVIDERS,
})
export class StorageModule { }
